<p-dropdown [panelStyleClass]="styleClass"
            [styleClass]="styleClass"
            [disabled]="!departments"
            [options]="departments"
            optionLabel="code"
            [(ngModel)]="selectedDepartment"
            [filter]="true"
            filterBy="code,description,company"
            [showClear]="true"
            [placeholder]="'DATA_MANAGEMENT.DEPARTMENT_PICKER_PLACEHOLDER' | translate"
            [virtualScroll]="true"
            [virtualScrollItemSize]="30"
            autoWidth="false"
            [style]="{ width: '350px' }">
  <ng-template pTemplate="selectedItem">
    <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: selectedDepartment }"></ng-container>
  </ng-template>

  <ng-template let-item
               pTemplate="item">
    <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
  </ng-template>
</p-dropdown>

<ng-template #itemTemplate
             let-department>
  <div *ngIf="department">
    {{ department.code }} {{' \u2022 '}} {{ department.description }} ({{ department.company }})
  </div>
</ng-template>
